import { Button, ModalV3, useTranslation } from '@helios/frontend-core';

import { Fragment } from 'react';
import { ProjectV2Response } from '../../../../../api/project/types';

import { ProjectSummary } from '../ProjectSummary/ProjectSummary';

interface ProjectSummaryListBottomSheetProps {
  isOpen: boolean;
  onDismiss: () => void;
  projects: ProjectV2Response[];
}

const TRACKING_ID = 'project-summary-list-bottom-sheet';

const ProjectSummaryListBottomSheet = ({ isOpen, onDismiss, projects }: ProjectSummaryListBottomSheetProps) => {
  const { t } = useTranslation();

  const dismissButton = (
    <div className="w-full">
      <Button
        trackingId={`${TRACKING_ID}-dismiss-button`}
        emphasis="tertiary"
        onClick={onDismiss}
        className="w-full text-text-primary"
      >
        {t('common.dismiss')}
      </Button>
    </div>
  );

  return (
    <ModalV3 open={isOpen} onClose={onDismiss} trackingId={TRACKING_ID} mobileCta={dismissButton}>
      <div className="flex flex-col gap-28">
        <h2 className="heading-300 text-text-primary">{t('homePage.yourProjects')}</h2>
        <div className="flex flex-col">
          {projects.map((project, index) => (
            <Fragment key={project._id}>
              <ProjectSummary project={project} />
              {index < projects.length - 1 && <hr className="my-24 border-t border-border-default" />}
            </Fragment>
          ))}
        </div>
      </div>
    </ModalV3>
  );
};

export default ProjectSummaryListBottomSheet;
